
// 通讯录
const contactsList = [
  {
    contactKey: 'contact',
    name: 'accountName',
    phone: 'accountPhone'
  },
  {
    contactKey: 'jdkan',
    name: 'jdkanxm',
    phone: 'jdkansj'
  },
  {
    contactKey: 'giwef',
    name: 'gerfs',
    phone: 'gehs'
  },
  {
    contactKey: 'qabvzd',
    name: 'eubfs',
    phone: 'eioba'
  },
  {
    contactKey: 'fhasjb',
    name: 'qwed',
    phone: 'wersd'
  },
  {
    contactKey: 'ijksfas',
    name: 'qwjnds',
    phone: 'diwhdf'
  },
  {
    contactKey: 'ifsnsq',
    name: 'iwqond',
    phone: 'wieojf'
  },
  {
    contactKey: 'sdfsasd',
    name: 'sdas',
    phone: 'feww'
  },
  {
    contactKey: 'weweree',
    name: 'werwe',
    phone: 'werer'
  },
  {
    contactKey: 'gerwerr',
    name: 'ererw',
    phone: 'werfd'
  },
  {
    contactKey: 'ioewrn',
    name: 'ewrew',
    phone: 'werwe'
  },
  {
    contactKey: 'fsdfdwe',
    name: 'were',
    phone: 'wrtg'
  },
  {
    contactKey: 'uwjeks',
    name: 'qfsd',
    phone: 'ityr'
  },
  {
    contactKey: 'gbcfy',
    name: 'cbdyh',
    phone: 'ibcgs'
  },
  {
    contactKey: 'ieyrasa',
    name: 'qewe',
    phone: 'fsde'
  },
  {
    contactKey: 'erinds',
    name: 'ewdas',
    phone: 'qwrgf'
  },
  {
    contactKey: 'wfjks',
    name: 'wers',
    phone: 'sdfs'
  },
  {
    contactKey: 'aswewer',
    name: 'asdqw',
    phone: 'efssw'
  },
  {
    contactKey: 'sdfwews',
    name: 'sdws',
    phone: 'dwwe'
  },
  {
    contactKey: 'sweerfss',
    name: 'fsdwe',
    phone: 'sdfwsew'
  },
  {
    contactKey: 'ajhsf',
    name: 'iwhufis',
    phone: 'mbfgey'
  },
  {
    contactKey: 'yutgdfef',
    name: 'sefwer',
    phone: 'sdfwerwer'
  },
  {
    contactKey: 'hkutyrgdfs',
    name: 'sdfsdvcx',
    phone: 'asqwrqw'
  },
  {
    contactKey: 'gthrrfd',
    name: 'dfgere',
    phone: 'sdfs'
  },
  {
    contactKey: 'snoxhgdn',
    name: 'dshy',
    phone: 'glqljeec'
  },
  {
    contactKey: 'djnetpqnomvw',
    name: 'ffurneux',
    phone: 'jyhpqgi'
  },
  {
    contactKey: 'ktwsbpns',
    name: 'heacifnnqm',
    phone: 'wqfxflsq'
  }

]
// 好评弹框方法
const scoreFuncNameList = [
  'hkjhfss',
  'jcfuidh',
  'jdjsa',
  'wegfdf',
  'wubkjsf',
  'wewres',
  'wewss',
  'dfwers',
  'rinsj',
  'thtrhggf',
  'fhtretfsd',
  'sdhfhajsf',
  'tvctnki',
  'bbtun',
  'vvgxrfgoq'
]
export { contactsList, scoreFuncNameList }
